import { Mutation } from 'vuex'
import { MediaLibraryState } from '../types'
import {
  MediaLibraryEssence,
  MediaLibraryImageItem,
} from '@/types/mediaLibrary'

const setImageMediaLibrary: Mutation<MediaLibraryState> = (
  state,
  {
    essence,
    image,
  }: { essence: MediaLibraryEssence; image: MediaLibraryImageItem }
) => {
  const mediaLibrary = new Map(state.value)
  const mediaLibraryItem = mediaLibrary.get(essence)

  if (mediaLibraryItem) {
    mediaLibraryItem.images.unshift(image)

    state.value = mediaLibrary
  }
}

export default setImageMediaLibrary
